import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { SequenceDocument, sequencesPullQueryBuilder } from './queryBuilder';

export function sequencesFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<SequenceDocument> {
  const syncConfig = configBuilder<SequenceDocument>(RxdbCollectionNameV2.SEQUENCES);
  doNotAutoSync(syncConfig);

  pull(syncConfig, sequencesPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.SEQUENCES, replicationState, [sites]);
}
